<template>
  <b-card>
    <div>
      <font-awesome-icon icon="user-tag" />
      {{ nbOfRepresentedMandates }} / {{ votingLimitRules.votesLimitPerMandate }}
      <b-badge :variant="votesLimitResult < 0 ? 'danger' : 'info'">
        {{ votesLimitResult }}
      </b-badge>
    </div>
    <hr />
    <div>
      {{ nbOfRepresentedTantiemes }} / {{ votingLimitRules.tantiemesLimitPerMandate }}
      <b-badge :variant="tantiemesLimitResult < 0 ? 'danger' : 'info'">
        {{ tantiemesLimitResult }}
      </b-badge>
    </div>
  </b-card>
</template>

<script>
export default {
  props: ["nbOfRepresentedMandates", "nbOfRepresentedTantiemes"],
  computed: {
    votesLimitResult() {
      var x = this.votingLimitRules.votesLimitPerMandate - this.nbOfRepresentedMandates;
      return x.toFixed();
    },
    tantiemesLimitResult() {
      var x = this.votingLimitRules.tantiemesLimitPerMandate - this.nbOfRepresentedTantiemes;
      return this.formatNumber(x);
    },
  },
};
</script>
